import React, { PropsWithChildren } from 'react';
import './col.scss';

function ColComponent({
    children,
    ...props
}: PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
    return (
        <div {...props} className={`col ${props.className ?? ''}`}>
            {children}
        </div>
    );
}

export default ColComponent;
